(() => {
  const body = document.body;
  if (!body) return;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const supportsPrefetch = (() => {
    const link = document.createElement('link');
    return !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  })();

  if (!supportsPrefetch) return;
  if (connection && (connection.saveData || /(^|-)2g$/i.test(connection.effectiveType || ''))) return;
  if (navigator.deviceMemory && navigator.deviceMemory <= 1) return;

  const allowQueryString = 'instantAllowQueryString' in body.dataset;
  const allowExternalLinks = 'instantAllowExternalLinks' in body.dataset;

  const prefetcher = document.createElement('link');
  prefetcher.rel = 'prefetch';
  document.head.appendChild(prefetcher);

  let urlToPreload;
  let mouseoverTimer;
  let lastTouchTimestamp = 0;
  let initialized = false;

  const listenerOptions = { capture: true, passive: true };

  function stopPreloading() {
    prefetcher.removeAttribute('href');
  }

  function preload(url) {
    prefetcher.href = url;
  }

  function isPreloadable(anchor) {
    if (!anchor || !anchor.href) return false;
    if (urlToPreload === anchor.href) return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.target === '_blank') return false;
    if (anchor.dataset.noInstant !== undefined) return false;

    const url = new URL(anchor.href, location.href);

    if (!allowExternalLinks && url.origin !== location.origin && anchor.dataset.instant === undefined) return false;
    if (!['http:', 'https:'].includes(url.protocol)) return false;
    if (url.protocol === 'http:' && location.protocol === 'https:') return false;
    if (!allowQueryString && url.search && anchor.dataset.instant === undefined) return false;
    if (url.hash && url.pathname + url.search === location.pathname + location.search) return false;

    return true;
  }

  function touchendAndTouchcancelListener() {
    urlToPreload = undefined;
    stopPreloading();
  }

  function touchstartListener(event) {
    lastTouchTimestamp = performance.now();

    const anchor = event.target.closest('a');
    if (!isPreloadable(anchor)) return;

    anchor.addEventListener('touchcancel', touchendAndTouchcancelListener, { passive: true });
    anchor.addEventListener('touchend', touchendAndTouchcancelListener, { passive: true });

    urlToPreload = anchor.href;
    preload(anchor.href);
  }

  function mouseoutListener(event) {
    if (event.relatedTarget && event.target.closest('a') === event.relatedTarget.closest('a')) return;

    if (mouseoverTimer) {
      clearTimeout(mouseoverTimer);
      mouseoverTimer = undefined;
      return;
    }

    urlToPreload = undefined;
    stopPreloading();
  }

  function mouseoverListener(event) {
    if (performance.now() - lastTouchTimestamp < 1100) return;

    const anchor = event.target.closest('a');
    if (!isPreloadable(anchor)) return;

    anchor.addEventListener('mouseout', mouseoutListener, { passive: true });

    urlToPreload = anchor.href;
    mouseoverTimer = window.setTimeout(() => {
      preload(anchor.href);
      mouseoverTimer = undefined;
    }, 80);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('touchstart', touchstartListener, listenerOptions);
    document.addEventListener('mouseover', mouseoverListener, listenerOptions);
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(init, { timeout: 1500 });
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
